import { useAuth0 } from '@auth0/auth0-react';
import api from 'lib/trpcClient';
import useHandleTrpcMutation from 'hooks/ui/useHandleTrpcMutation';
import { QUERY_STALE_TIME_MS } from 'further-ui/config';

export default function useCurrentUser() {
  const apiUtils = api.useUtils();
  const { isAuthenticated } = useAuth0();

  return {
    profile: api.adminUser.profile.useQuery(undefined, {
      retry: 1,
      enabled: isAuthenticated,
      placeholderData: undefined,
      refetchOnWindowFocus: false,
      staleTime: QUERY_STALE_TIME_MS,
    }),
    updateProfile: api.adminUser.updateProfile.useMutation({
      onSuccess: () => {
        apiUtils.adminUser.profile.invalidate();
      },
    }),
    requestPasswordResetForSelf:
      api.adminUser.requestPasswordResetForSelf.useMutation(
        useHandleTrpcMutation()({
          successMessage: 'Password reset email sent.',
        }),
      ),
  };
}
